import React from 'react';

import { Badge, Text } from '@/design-system/components/ui';

interface Props {
  label: string;
  value: string | React.ReactNode;
}

export const TriggerValueDetail = ({ label, value }: Props) => {
  return (
    <div className="tw:flex tw:flex-col">
      <Text variant="body-sm" weight="bold" className="tw:mb-1">
        {label}
      </Text>
      {typeof value === 'string' ? <Badge size="sm">{value || 'N/A'}</Badge> : value || 'N/A'}
    </div>
  );
};
